// extracted by mini-css-extract-plugin
module.exports = {"bannerWrapper":"styles_bannerWrapper__2ZzKb","bannerImage":"styles_bannerImage__2RnOg"};